import { render, staticRenderFns } from "./DrawingRequestShowTabs.vue?vue&type=template&id=0007e94d&scoped=true&"
import script from "./DrawingRequestShowTabs.vue?vue&type=script&lang=js&"
export * from "./DrawingRequestShowTabs.vue?vue&type=script&lang=js&"
import style0 from "./DrawingRequestShowTabs.vue?vue&type=style&index=0&id=0007e94d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0007e94d",
  null
  
)

export default component.exports